<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";

export default {
  page: {
    title: "Journal Entry",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Journal Entry",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Journal Entry",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "added_to_details",
          sortable: false,
          label: "Transaction Details",
        },
        {
          key: "amount",
          sortable: false,
          label: "Amount",
        },
        {
          key: "description",
          sortable: false,
          label: "Description",
        },
        {
          key: "date",
          sortable: false,
          label: "Date",
        },
        {
          key: "user.name",
          sortable: false,
          label: "Transacted By",
        },
      ],
      data: {
        fromAccount: "",
        toAccount: "",
        amount: "",
        desc: "",
      },
      fromAccountError: "",
      toAccountError: "",
    };
  },

  computed: {
    ...mapGetters("accounts", [
      "getMappAccounts",
      "SaveStatus",
      "Journalentries",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  watch: {
    // getSmsCalc() {
    // },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Journalentries ? this.Journalentries.length : 1;
  },
  methods: {
    ...mapActions({
      FetchMappAccounts: "accounts/fetchMappAccounts",
      FetchJournalEntries: "accounts/fetchJournalEntries",
      SubmitJournalEntry: "accounts/submitJournalEntry",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    makeJournalEntry() {
      if (this.data.fromAccount === "") {
        this.fromAccountError = "Please Select Account";
        return;
      } else {
        this.fromAccountError = "";
      }
      if (this.data.toAccount === "") {
        this.toAccountError = "Please Select Account";
        return;
      } else {
        this.toAccountError = "";
      }
      this.SubmitJournalEntry(this.data);
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    checkAccountStatements(data) {
      var addedAccount = "";
      var addType = "";
      var removedAccount = "";
      var removeType = "";
      var fristStatement = "";
      var secondStatement = "";
      if (data.item.added_to_details) {
        addedAccount = data.item.added_to_details.acc_name;
        addType = data.item.added_to_details.acc_type;
      }
      switch (addType) {
        case "ASSET":
          fristStatement = "Debited: <b>" + addedAccount + "</b>";
          break;

        case "LIABILITIES":
          fristStatement = "Credited: <b>" + addedAccount + "</b>";
          break;

        case "REVENUE":
          fristStatement = "Debited: <b>" + addedAccount + "</b>";
          break;

        case "EXPENSES":
          fristStatement = "Credited: <b>" + addedAccount + "</b>";
          break;

        case "EQUITY":
          fristStatement = "Debited: <b>" + addedAccount + "</b>";
          break;

        default:
          break;
      }

      if (data.item.sub_from_details) {
        removedAccount = data.item.sub_from_details.acc_name;
        removeType = data.item.sub_from_details.acc_type;
      }
      switch (removeType) {
        case "ASSET":
          secondStatement = "Credited: <b>" + removedAccount + "</b>";
          break;

        case "LIABILITIES":
          secondStatement = "Debited: <b>" + removedAccount + "</b>";
          break;

        case "REVENUE":
          secondStatement = "Credited: <b>" + removedAccount + "</b>";
          break;

        case "EXPENSES":
          secondStatement = "Debited: <b>" + removedAccount + "</b>";
          break;

        case "EQUITY":
          secondStatement = "Credited: <b>" + removedAccount + "</b>";
          break;

        default:
          break;
      }

      if (fristStatement) {
        return fristStatement.includes("Debited")
          ? fristStatement + "<br/>" + secondStatement
          : secondStatement + "<br/>" + fristStatement;
      } else {
        return secondStatement.includes("Debited")
          ? secondStatement + "<br/>" + fristStatement
          : fristStatement + "<br/>" + secondStatement;
      }
    },
  },
  created() {
    this.FetchMappAccounts();
    this.FetchJournalEntries();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row d-flex"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_total_students')
        )
      "
    >
      <div class="col-md-12 mx-auto">
        <div class="card row">
          <div class="card-body col-md-12 d-flex row">
            <form
              @submit.prevent="makeJournalEntry"
              class="col-md-12 mx-auto row"
            >
              <div class="row">
                <div class="form-group col-md-3">
                  <label
                    >From Account <small class="text-danger">*</small></label
                  >
                  <model-list-select
                    required
                    :list="getMappAccounts ? getMappAccounts : []"
                    v-model="data.fromAccount"
                    option-value="id"
                    option-text="acc_name"
                    class="mb-2"
                    placeholder="Select Account"
                  >
                  </model-list-select>
                  <div class="text-danger" v-if="fromAccountError">
                    <em>{{ fromAccountError }}</em>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label>To Account <small class="text-danger">*</small></label>
                  <model-list-select
                    required
                    :list="getMappAccounts ? getMappAccounts : []"
                    v-model="data.toAccount"
                    option-value="id"
                    option-text="acc_name"
                    class="mb-2"
                    placeholder="Select Account"
                  >
                  </model-list-select>
                  <div class="text-danger" v-if="toAccountError">
                    <em>{{ toAccountError }}</em>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label>Amount <small class="text-danger">*</small></label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.amount"
                    required
                  />
                </div>
              </div>
              <div class="row">
                <div class="form-group mb-3 col-md-3">
                  <label
                    >Description/Reason
                    <small class="text-danger">*</small></label
                  >
                  <textarea
                    v-model="data.desc"
                    class="form-control"
                    maxlength="200"
                    rows="2"
                    required
                    placeholder="Enter Reason for the Journal Entry"
                  ></textarea>
                </div>
                <div class="form-group col-md-3 mt-1">
                  <button
                    v-if="SaveStatus"
                    disabled
                    type="button"
                    class="btn btn-outline-success mt-4"
                  >
                    <b-spinner
                      variant="priamry"
                      small
                      label="Spinning"
                    ></b-spinner>
                    Saving Journal Entry...
                  </button>
                  <button
                    v-else
                    type="submit"
                    class="btn btn-outline-success mt-4"
                  >
                    <i class="fa fa-save"></i>
                    Save Journal Entry
                  </button>
                </div>
              </div>
            </form>
            <hr />
            <div class="col-md-12">
              <b-card class="mb-2" no-body>
                <b-row no-gutters class="align-items-center">
                  <b-col md="12">
                    <b-card-header
                      ><h5
                        class="card-title mb-2 text-uppercase font-weight-boldw"
                      >
                        Journal Entries
                      </h5></b-card-header
                    >
                    <b-card-body>
                      <div class="row mt-4">
                        <div class="col-sm-12 col-md-6">
                          <div
                            id="tickets-table_length"
                            class="dataTables_length"
                          >
                            <label class="d-inline-flex align-items-center">
                              Show&nbsp;
                              <b-form-select
                                class="form-select form-select-sm"
                                v-model="perPage"
                                size="sm"
                                :options="pageOptions"
                              ></b-form-select
                              >&nbsp;entries
                            </label>
                          </div>
                        </div>
                        <!-- Search -->
                        <div class="col-sm-12 col-md-6">
                          <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-end"
                          >
                            <label class="d-inline-flex align-items-center">
                              Search:
                              <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Search..."
                                class="form-control form-control-sm ms-2"
                              ></b-form-input>
                            </label>
                          </div>
                        </div>
                        <!-- End search -->
                      </div>
                      <!-- Table -->
                      <div class="table-responsive mb-0">
                        <b-table
                          class="datatables"
                          :items="Journalentries ? Journalentries : []"
                          :fields="fields"
                          responsive="sm"
                          :per-page="perPage"
                          :current-page="currentPage"
                          :sort-desc.sync="sortDesc"
                          :filter="filter"
                          :filter-included-fields="filterOn"
                          @filtered="onFiltered"
                        >
                          <template #cell(added_to_details)="data">
                            <div
                              v-html="checkAccountStatements(data)"
                              class="px-5"
                            ></div>
                          </template>
                          <template #cell(amount)="data">
                            <div class="px-5">
                              {{
                                parseInt(data.item.amount) != 0
                                  ? thousandSeperator(data.item.amount)
                                  : thousandSeperator(
                                      data.item.correct_amounts.amount
                                    )
                              }}
                            </div>
                          </template>
                        </b-table>
                      </div>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
